import strFunc from "@/lib/lyg/string";
import DateFunc from '@/lib/lyg/date_func';
import { useState, useEffect, useRef } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector } from 'react-redux';
import LoadingComponent from "@/pcomponents/common/content/loading";
import SelectStuArea from "./area/select_stu";
import WriteArea from "./area/write";
import PreListArea from "./area/pre_list";

function WriteByStuArea(props: any) {
  let myProps = {
    close_text: "닫기",
    close_func: () => { },
    callback_refresh: () => { },
    callback_complete: (inData: any) => { },
    callback_delete_todoc: (inData: any) => { },
    select_date: "",
    subject_name: "",
    stu_seq_arr: [],
    sort: "complete",//complete,pass,special
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let select_date = myProps.select_date;
  if (strFunc.is_empty(select_date)) {
    select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
  }

  const [stu_info_arr, set_stu_info_arr] = useState([]);
  const [todo_dailyc_data, set_todo_dailyc_data] = useState({
    a_date: select_date,
    a_subject: myProps.subject_name,
    a_stu_seq: "",
    a_sort: myProps.sort,
    a_memo: "",
    a_writer_seq: user.user_seq,
    a_writer: user.user_name,
  });
  const [todo_dailyc_arr, set_todo_dailyc_arr] = useState([]);
  const memo_input_ref = useRef<any>(null);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  useEffect(() => {
    get_stu_info_by_ajax({});
  }, [myProps.stu_seq_arr]);
  useEffect(() => {
    setTimeout(() => {
      if (memo_input_ref.current) {
        memo_input_ref.current.focus();
      }
    }, 100);
  }, []);

  const get_stu_info_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: myProps.stu_seq_arr,
      ...inData
    };
    if (opt_obj.stu_seq_arr.length == 0) {
      return false;
    }
    let form_json_data = {
      "s_seq": opt_obj.stu_seq_arr,
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_stu_info_arr(response.data["data"]["info_arr"]);
          get_todo_dailyc_by_ajax({});
        } else {

        }
      });
  };
  const get_todo_dailyc_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: myProps.stu_seq_arr,
      ...inData
    };
    if (opt_obj.stu_seq_arr.length == 0) {
      return false;
    }
    let form_json_data = {
      "s_stu_seq": opt_obj.stu_seq_arr,
      "s_date_type": "a_date",
      "s_start_date": todo_dailyc_data.a_date,
      "s_end_date": todo_dailyc_data.a_date,
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_todo_dailyc_arr(response.data["data"]["info_arr"]);
          if (opt_obj.stu_seq_arr.length == 1) {
            let pre_data = null;
            for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
              let row_data = response.data["data"]["info_arr"][i];
              if (row_data["a_subject"] == todo_dailyc_data.a_subject
                && row_data["a_date"] == todo_dailyc_data.a_date
              ) {
                pre_data = row_data;
              }
            }
            if (pre_data != null) {
              set_todo_dailyc_data({
                ...todo_dailyc_data,
                ...pre_data
              });
            }
          }
        } else {

        }
      });
  };

  const go_todo_dailyc_write = (inData: any) => {
    let opt_obj = {
      ...inData
    };

    if (strFunc.is_empty(todo_dailyc_data.a_date)) {
      alert("날짜를 선택하세요.");
      return false;
    }
    if (strFunc.is_empty(todo_dailyc_data.a_subject)) {
      alert("과목을 선택하세요.");
      return false;
    }
    if (strFunc.is_empty(todo_dailyc_data.a_sort)) {
      alert("구분을 선택하세요.");
      return false;
    }
    if (stu_info_arr.length == 0) {
      alert("학생을 선택하세요.");
      return false;
    }
    // if (!confirm("저장하시겠습니까?")) {
    //   return false;
    // }

    let write_todo_dailyc_arr: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      let stu_info = stu_info_arr[i];
      let stu_seq = stu_info["a_seq"];
      let stu_name = stu_info["a_user_name"];
      let todo_dailyc_data_obj = {
        ...todo_dailyc_data,
        a_stu_seq: stu_seq,
        a_stu_name: stu_name,
        a_writer_seq: user.user_seq,
        a_writer: user.user_name,
      };
      write_todo_dailyc_arr.push(todo_dailyc_data_obj);
    }
    let form_json_data = {
      "data_arr": write_todo_dailyc_arr,
      "is_default_val": "1",
      "is_auto_add_star": "1",
      "is_desk_end": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "저장 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
          let end_desk_use_arr:any=[];
          if (response.data["end_desk_use_arr"] && response.data["end_desk_use_arr"].length > 0) {
           end_desk_use_arr = response.data["end_desk_use_arr"];
          }
          myProps.callback_complete({
            todo_dailyc_arr: response.data["data"],
            end_desk_use_arr: end_desk_use_arr,
          });
          myProps.callback_refresh();
          myProps.close_func();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  return (
    <div style={{ width: "98%", margin: "0 auto" }}>
      <div>
        <SelectStuArea
          stu_info_arr={stu_info_arr}
          set_stu_info_arr={set_stu_info_arr}
        ></SelectStuArea>
      </div>
      <div className="mt-1">
        <WriteArea
          todo_dailyc_data={todo_dailyc_data}
          set_todo_dailyc_data={set_todo_dailyc_data}
          memo_input_ref={memo_input_ref}
        ></WriteArea>
      </div>
      <div className="mt-1 text-center">
        <button className="btn-l btn-sky" onClick={() => { go_todo_dailyc_write({}); }}>완료처리</button>
        <button className="btn-l btn-dark ml-1" onClick={() => { myProps.close_func(); }}>{myProps.close_text}</button>
      </div>
      <div className="mt-1">
        <PreListArea
          todo_dailyc_data={todo_dailyc_data}
          todo_dailyc_arr={todo_dailyc_arr}
          callback_delete_todoc={(inData:any)=>{
            myProps.callback_delete_todoc(inData);
          }}
          refresh_data={() => {
            get_todo_dailyc_by_ajax({});
            myProps.callback_refresh();
          }}
          loading_data={loading_data}
          set_loading_data={set_loading_data}
        ></PreListArea>
      </div>
      <LoadingComponent is_display={loading_data.is_display} text={loading_data.text}></LoadingComponent>
    </div>
  );
};
export default WriteByStuArea;